import { THEME_NAME } from '@constants/siteDetails'
let themeName = THEME_NAME
export default () => import(`@layouts/${themeName}Layout`)
